import * as React from "react";

function SvgSnow(props) {
  return (
    <svg viewBox="0 0 227.73 227.73" {...props}>
      <circle cx={183.082} cy={187.694} r={10.499} />
      <circle cx={137.27} cy={187.694} r={10.499} />
      <circle cx={91.139} cy={187.694} r={10.499} />
      <circle cx={45.328} cy={187.694} r={10.499} />
      <circle cx={160.27} cy={216.486} r={10.498} />
      <circle cx={114.139} cy={216.486} r={10.498} />
      <circle cx={68.328} cy={216.486} r={10.498} />
      <path d="M169.316 39.469a59.52 59.52 0 00-3.582.108C155.938 16.434 132.434.746 106.513.746c-35.335 0-64.082 28.178-64.082 62.813l.001.365C18.732 65.706 0 85.2 0 108.906c0 24.876 20.625 45.113 45.977 45.113h123.34c32.209 0 58.414-25.694 58.414-57.275s-26.205-57.275-58.415-57.275zm0 99.551H45.977C28.896 139.02 15 125.511 15 108.906s13.896-30.115 30.977-30.115c1.054 0 2.226.08 3.687.25a7.5 7.5 0 008.291-8.532 48.385 48.385 0 01-.523-6.951c0-26.364 22.018-47.813 49.082-47.813 21.54 0 40.879 14.036 47.027 34.132a7.496 7.496 0 008.412 5.202 44.629 44.629 0 017.363-.611c23.938 0 43.414 18.965 43.414 42.275 0 23.312-19.475 42.277-43.414 42.277z" />
    </svg>
  );
}

export default SvgSnow;
